import { render, staticRenderFns } from "./ClockForm.vue?vue&type=template&id=7844cc8a&scoped=true&"
import script from "./ClockForm.vue?vue&type=script&lang=ts&"
export * from "./ClockForm.vue?vue&type=script&lang=ts&"
import style0 from "./ClockForm.vue?vue&type=style&index=0&id=7844cc8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7844cc8a",
  null
  
)

export default component.exports